import { useQuery } from "@tanstack/react-query";
import { milestoneKeys } from "components/milestone/queries";
import { calculateTotalHours } from "utils/utils";
import { fetchTimesheetApprovedHoursForMilestone } from "components/milestone/stats/consumed/api";

export function useMilestoneApprovedHours(id, dateRange) {
  return useQuery({
    queryFn: () => fetchTimesheetApprovedHoursForMilestone({ id, dateRange }),
    queryKey: milestoneKeys.allApprovedHours(id, dateRange),
    select: (data) => calculateTotalHours(data, "approved_hours"),
    enabled: !!id,
  });
}
